import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Headphones, ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { getProgress } from "../lib/readingProgress";

// Home-screen "Continue listening" chip. Picks the most-recently-read of
// the Bible / Apocrypha and links straight into the reader with the
// narration auto-starting at the saved verse (?listen=1&fromVerse=N).
// Purely additive — reuses the existing reading-progress store.
export default function ResumeListeningChip() {
  const { user } = useAuth();
  const [best, setBest] = useState(null);

  useEffect(() => {
    let alive = true;
    const authed = !!(user && user !== false);
    Promise.all([
      getProgress("bible", { authed }).catch(() => null),
      getProgress("apocrypha", { authed }).catch(() => null),
    ]).then(([b, a]) => {
      if (!alive) return;
      const cands = [
        b && b.book ? { ...b, surface: "bible" } : null,
        a && a.book ? { ...a, surface: "apocrypha" } : null,
      ].filter(Boolean);
      if (!cands.length) return;
      cands.sort((x, y) => String(y.updated_at || "").localeCompare(String(x.updated_at || "")));
      setBest(cands[0]);
    });
    return () => { alive = false; };
  }, [user]);

  if (!best) return null;
  const base = best.surface === "apocrypha" ? "/apocrypha" : "/bible";
  const v = best.verse || 1;
  const to = `${base}/${best.book}/${best.chapter}?verse=${v}&listen=1&fromVerse=${v}`;
  const label = `${best.book_name || best.book} ${best.chapter}:${v}`;

  return (
    <Link
      to={to}
      data-testid="home-continue-listening"
      className="group inline-flex items-center gap-3 rounded-full border border-terracotta/30 bg-terracotta/10 hover:bg-terracotta/15 pl-2 pr-4 py-1.5 transition-colors"
    >
      <span className="shrink-0 w-8 h-8 rounded-full bg-terracotta text-cream grid place-items-center">
        <Headphones size={16} weight="fill" />
      </span>
      <span className="min-w-0">
        <span className="block text-[10px] uppercase tracking-[0.18em] text-terracotta font-bold leading-none">Continue listening</span>
        <span className="block text-forest font-semibold text-sm truncate leading-tight">{label}</span>
      </span>
      <ArrowRight size={16} weight="bold" className="text-terracotta shrink-0 group-hover:translate-x-1 transition-transform" />
    </Link>
  );
}
